import { render, staticRenderFns } from "./vendor-details-reviews.vue?vue&type=template&id=d59f8f28&scoped=true"
import script from "./vendor-details-reviews.vue?vue&type=script&lang=js"
export * from "./vendor-details-reviews.vue?vue&type=script&lang=js"
import style0 from "./vendor-details-reviews.vue?vue&type=style&index=0&id=d59f8f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59f8f28",
  null
  
)

export default component.exports